import { sortByKey } from '../../utils';

const getCommunityId = (props) => Number(props?.match?.params?.id);
const getCommunityList = (state) => state?.community?.list || {};
const getCommunityUnpagedList = (state) =>
  state?.community?.unpagedList?.sort((a, b) => sortByKey(a, b, 'name')) || [];
const getCommunityById = (state, communityId) =>
  getCommunityUnpagedList(state).find(({ id }) => id === communityId) || {};

const getPostsList = (state) => state?.community?.postsList || {};
const getPostById = (state, { currentPostId, post }) => {
  if (post?.id === currentPostId) return post;
  return (
    state?.community?.postsList?.results?.find(
      ({ id }) => id === currentPostId,
    ) || {}
  );
};

const getPostCommentsList = (state, { currentPostId, defaultValue = {} }) =>
  state?.community?.postsCommentsList?.[currentPostId] || defaultValue;

const getCommunityMembers = (state) =>
  state?.community?.communityMembersList || {};
const getCommunityMessagesList = (state) =>
  state?.community?.communityChats?.results || [];
const getCommunityCurrentChat = (state) =>
  state?.community?.currentChat?.results || [];
const getCommunityCurrentMessage = (state) =>
  state?.community?.newMessage || {};

const getExpandedByDefault = (state) => {
  const items = getPostsList(state);
  const expanded = {};
  items?.results?.forEach(({ id, pendingComments }, index) => {
    if (pendingComments?.length) {
      expanded[index] = { id };
    }
  });
  return expanded;
};

export {
  getCommunityId,
  getCommunityList,
  getPostsList,
  getCommunityUnpagedList,
  getCommunityById,
  getPostById,
  getPostCommentsList,
  getCommunityMembers,
  getCommunityMessagesList,
  getCommunityCurrentChat,
  getCommunityCurrentMessage,
  getExpandedByDefault,
};
